import React, { useState, useEffect } from 'react';

const TripInfoForm = ({formData, cities, onNavigate }) => {
  var today = new Date();
  const [city, setCity] = useState("");
  const [startDate, setStartDate] = useState(
    today.getFullYear() + '-' + 
    String(today.getMonth() + 1).padStart(2, '0') + '-' + 
    String(today.getDate()).padStart(2, '0')
  );
  const [endDate, setEndDate] = useState(
    today.getFullYear() + '-' + 
    String(today.getMonth() + 1).padStart(2, '0') + '-' + 
    String(today.getDate() + 4).padStart(2, '0')
  );
  const [startTime, setStartTime] = useState(formData['start_day_time']);
  const [endTime, setEndTime] = useState(formData['end_day_time']);

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
  };

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
  };

  const handleCityChange = (event) => {
    setCity(event.target.value);
  };

  const handleStartTimeChange = (event) => {
    setStartTime(event.target.value);
  };

  const handleEndTimeChange = (event) => {
    setEndTime(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const newData = {
      ...formData,
      start_date_time: startDate + " " + startTime,
      end_date_time: endDate + " " + endTime,
      city_id: city
    };
    onNavigate(newData);
  };

  useEffect(() => {
      const selectElement = document.querySelector('select');
  
      const handleToggle = () => selectElement.classList.toggle('select-open');
      const handleOutClick = () => selectElement.classList.remove('select-open')
      
      selectElement.addEventListener('click', handleToggle);
      selectElement.addEventListener('blur', handleOutClick);
      return () => {
        selectElement.removeEventListener('click', handleToggle);
        selectElement.addEventListener('blur', handleOutClick);
      };
    }, []);
  

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <header className='form-header'>
          <h1>Trip details</h1>
        </header>
        <div className="form-container">
          <div className='input-datetime'>
              <label className='date-label'>Start Date:</label>
              <input
              type="date"
              id="startdate"
              name="startdate"
              min="2025-01-25"
              value={startDate}
              onChange={handleStartDateChange}
              placeholder="Enter Trip Start Date"
              />
              <input
              type="time"
              id="starttime"
              name="starttime"
              value={startTime}
              onChange={handleStartTimeChange}
              />
          </div>
          <div className='input-datetime'>
              <label className='date-label'>End Date:</label>
              <input
              type="date"
              id="enddate"
              name="enddate"
              value={endDate}
              onChange={handleEndDateChange}
              placeholder="Enter Trip End Date"
              />
              <input
              type="time"
              id="endtime"
              name="endtime"
              value={endTime}
              onChange={handleEndTimeChange}
              />
          </div>
          <select id="city" className='input-field-regular' name="city" value={city} onChange={handleCityChange} required>
            <option value="" disabled>Select city of trip</option>
              {cities.map((city) => (
              <option key={city.city_id} value={city.city_id}>
                {city.city_name}
              </option>
            ))}
          </select>
        </div>
        <button type="submit" >Submit</button>
      </form>
    </div>
  );
};

export default TripInfoForm;
